import { useSelector } from "react-redux";
import type { CsticId } from "~/features/configurator/Linear/models";
import { selectCstic } from "~/features/configurator/Linear/redux/selectCstic";
import { NumberFormatter } from "~/common/utils/NumberFormatter";

export function useMinMaxCsticLabel({
  minCsticId,
  maxCsticId,
  unit,
}: {
  minCsticId: CsticId;
  maxCsticId: CsticId;
  unit: string;
}) {
  const minCsticVal = useSelector(selectCstic(minCsticId))?.value;
  const maxCsticVal = useSelector(selectCstic(maxCsticId))?.value;
  return formatMinMaxLabel(minCsticVal, maxCsticVal, unit);
}

export function formatMinMaxLabel(min: string | undefined | null, max: string | undefined | null, unit: string) {
  min = formatCsticValueAsNumber(min);
  max = formatCsticValueAsNumber(max);
  return `${min}${unit} - ${max}${unit}`;
}

export function formatCsticValueAsNumber(
  value: string | undefined | null,
  maximumFractionDigits = 2,
  minimumFractionDigits = 0,
) {
  let val = "?";
  if (value) {
    const numVal = +value;
    if (!isNaN(numVal)) {
      val = NumberFormatter.getFormatter({
        minimumFractionDigits,
        maximumFractionDigits,
      }).format(numVal);
    }
  }
  return val;
}
